export * from 'utility-ts-orm';



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-datasource/src/main.ts